/**
 * TypeScript types for User Management
 */

export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  CLIENT_ADMIN = 'CLIENT_ADMIN',
  FACILITY_ADMIN = 'FACILITY_ADMIN',
  ADMIN = 'ADMIN',
  NURSE = 'NURSE',
  DOCTOR = 'DOCTOR',
  SOCIAL_WORKER = 'SOCIAL_WORKER',
  PHARMACIST = 'PHARMACIST',
  BILLING_SPECIALIST = 'BILLING_SPECIALIST',
}

export interface UserDTO {
  id?: string;
  keycloakId?: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  role: UserRole;
  isActive?: boolean;
  emailVerified?: boolean;
  profilePictureUrl?: string;
  employeeId?: string;
  licenseNumber?: string;
  department?: string;
  jobTitle?: string;
  hireDate?: string;
  lastLoginAt?: string;
  notes?: string;
  tenantId?: string;
  facilityId?: string;
  clientId?: string;
  createdAt?: string;
  updatedAt?: string;
  fullName?: string;
}

export interface CreateUserRequest {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  phone?: string;
  role: UserRole;
  profilePictureUrl?: string;
  employeeId?: string;
  licenseNumber?: string;
  department?: string;
  jobTitle?: string;
  hireDate?: string;
  notes?: string;
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}
